export enum MessageType {
    ADD_TO_CART = 'ADD_TO_CART',
}

export type MessagePayload = {
    _type: MessageType;
    payload: object;
};

export const postMessage = (
    target: WindowProxy | undefined,
    type: MessageType,
    payload: object
) => {
    if (typeof target === 'undefined') return false;

    const event: MessagePayload = {
        _type: type,
        payload,
    };

    target.postMessage(event, { targetOrigin: '*' });

    return true;
};
